import {
  GatewayDatosUsuarioResponse,
  GatewayLoginResponse,
  GatewayUsuarioRow,
} from './gateway-auth.types';

/** Extrae JWT de la respuesta de POST /login (tolerante a variantes de nombre). */
export function extractGatewayJwt(loginResp: GatewayLoginResponse | unknown): string | null {
  if (!loginResp || typeof loginResp !== 'object') {
    return null;
  }
  const o = loginResp as Record<string, unknown>;
  const nested = o['data'] as Record<string, unknown> | undefined;
  const t =
    o['token'] ??
    o['access_token'] ??
    nested?.['token'] ??
    nested?.['access_token'];
  return typeof t === 'string' && t.length > 0 ? t : null;
}

/**
 * Misma forma que construye AccountService.loginPolpaico a partir de `datos[0]`.
 * Sirve para la respuesta de POST /datos-usuario.
 */
export function mapGatewayDatosRowToMixerUserLogged(row: GatewayUsuarioRow): Record<string, unknown> {
  const rol = String(row['ROL'] ?? '');
  return {
    USUARIOERO: row['USUARIOERO'],
    PASSWORDERO: row['PASSWORDERO'],
    APIKEYERO: row['APIKEYERO'],
    RUT_EMPRESA: row['RUT_M'],
    NOMBRE_EMPRESA: row['NOMBRE_M'],
    NOMBRE_USUARIO: row['NOMBRE_M'],
    RUT_USUARIO: row['RUT_M'],
    MAIL_USUARIO: row['EMAIL_M'],
    ADM: '0',
    FONO_USUARIO: row['CELULAR_M'],
    KEY: row['KEY'],
    OBRASNOTIFICACIONES: row['OBRAS'],
    CARGO: 'MIXER',
    ROL: row['ROL'],
    INTERNO: row['INTERNO'],
    VIAJES_M: row['VIAJESH'],
    OBRAS: [],
    ESTADO: row['ESTADO'],
    firma: '',
    DIAS_DESDE_ULTIMA_ENCUESTA:
      rol.toUpperCase() === 'MIXER' ? row['DIAS_DESDE_ULTIMA_ENCUESTA'] : null,
    OPERADOR_DE_PLANTA: row['OPERADOR_DE_PLANTA'],
    PLANTA_M: row['PLANTA_M'],
  };
}

/** Envelope compatible con lo que espera LoginComponent tras login. */
export function buildLoginComponentPayload(
  loginResp: GatewayLoginResponse,
  datosResp: GatewayDatosUsuarioResponse,
  datos: GatewayUsuarioRow[]
): GatewayDatosUsuarioResponse & { length: number; Estado: boolean } {
  const estadoRaw =
    loginResp['Estado'] ?? datosResp['Estado'] ?? false;
  const Estado =
    typeof estadoRaw === 'string'
      ? estadoRaw === 'true' || estadoRaw === '1'
      : Boolean(estadoRaw);

  return {
    ...datosResp,
    datos,
    length: datos.length,
    Estado,
  } as GatewayDatosUsuarioResponse & { length: number; Estado: boolean };
}
